import { Link, useLocation } from 'react-router-dom';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Function to check if the segment is likely an ID (numeric or alphanumeric)
  const isId = (segment: string): boolean => /^[a-fA-F0-9]{24}$/.test(segment) || /^\d+$/.test(segment);

  // Function to create a readable label from the pathname
  const readablePathname = (pathname: string) => pathname.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

  // Calculate the number of valid path segments
  const validPathSegments = pathnames.filter((x) => !isId(x));

  // Modify the last segment to remove the last part if it's an ID
  const modifyLastSegment = (segments: string[]) => {
    if (segments.length === 0) return segments;

    const lastSegment = segments[segments.length - 1];
    const parts = lastSegment.split('-');
    if (parts.length > 1 && isId(parts[parts.length - 1])) {
      parts.pop(); // Remove the last part if it's an ID
      segments[segments.length - 1] = parts.join('-');
    }
    return segments;
  };

  // Apply the modification to the pathnames
  const modifiedPathnames = modifyLastSegment([...pathnames]);

  return (
    <nav className="overflow-x-auto whitespace-nowrap">
      <ul className="breadcrumbs flex items-center space-x-2">
        <li className="">
          <Link to="/">Home</Link>
        </li>
        {modifiedPathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const label = readablePathname(value);
          const isLast = index === modifiedPathnames.length - 1;
          const isResort = label.toLowerCase() === 'resort';

          return (
            <li key={to} className={`flex items-center space-x-2 ${isLast ? 'last-breadcrumb' : ''}`}>
              {isResort ? (
                <span className="truncate">{label}</span>
              ) : validPathSegments.length === 2 && index === 1 ? (
                <span className="truncate">{label}</span>
              ) : validPathSegments.length > 2 && index > 0 ? (
                <span className="truncate">{label}</span>
              ) : (
                <Link to={to} className="truncate">{label}</Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
